import { Plugin } from '@ckeditor/ckeditor5-core';
import Widget from '@ckeditor/ckeditor5-widget/src/widget';
import { toWidget } from 'ckeditor5/src/widget';

export default class MediaBrowserEditing extends Plugin {
	static get requires() {
		return [Widget];
	}

	init() {
		this._defineSchema();
		this._defineConverters();
	}

	_defineSchema() {
		const schema = this.editor.model.schema;

		schema.register('video', {
			isObject: true,
			isBlock: true,
			allowWhere: '$block',
			allowAttributes: ['data-source'],
		});
	}

	_defineConverters() {
		const conversion = this.editor.conversion;
		const t = this.editor.t;

		// Model -> Data
		conversion.for('dataDowncast').elementToElement({
			model: 'video',
			view: (modelElement, { writer }) =>
				createVideoView(modelElement, writer),
		});

		// Model -> View (element)
		conversion.for('editingDowncast').elementToElement({
			model: 'video',
			view: (modelElement, { writer }) => {
				const element = createVideoView(modelElement, writer);
				return toMediaWidget(element, writer, t('video widget'));
			},
		});

		// View -> Model
		conversion.for('upcast').elementToElement({
			view: {
				name: 'video',
				attributes: {
					'data-source': true,
				},
			},
			model: (viewMedia, { writer }) => {
				const source = viewMedia.getAttribute('data-source');
				return writer.createRawElement('video', { source });
			},
		});
	}
}

function toMediaWidget(viewElement, writer, label) {
	writer.setCustomProperty('video', true, viewElement);

	return toWidget(viewElement, writer, { label });
}

function createVideoView(modelElement, writer) {
	const url = modelElement.getAttribute('data-source');
	const viewAttributes = { class: 'media', 'data-source': url };
	const viewElement = writer.createContainerElement('div', viewAttributes);

	const videoAttributes = { controls: '' };
	const videoElement = writer.createContainerElement(
		'video',
		videoAttributes
	);

	const sourceAttributes = { src: url };
	const sourceElement = writer.createRawElement('source', sourceAttributes);

	writer.insert(writer.createPositionAt(viewElement, 0), videoElement);
	writer.insert(writer.createPositionAt(videoElement, 0), sourceElement);

	return viewElement;
}
